import { Prop, Component } from 'vue-property-decorator'
import ClvrComponent from '../../../modules/system/vue/Core/ClvrComponent'

@Component({
    components: {},
})
export default class FormBaseComponentEmpty extends ClvrComponent {
    @Prop() public context: any
}
